module.exports = __webpack_public_path__ + "static/media/IM.9e4c9198.svg";